import serialize, { Children } from "./serialize";
import { defaultLanguageCode } from "@pslifestyle/common/src/models/languages";
import { LocalizedRichTextSchema } from "@pslifestyle/common/src/schemas";
import React from "react";

export type RichTextProps =
  | {
      className?: string;
      content: unknown;
      localizedContent: LocalizedRichTextSchema[];
      languageCode: string;
    }
  | {
      className?: string;
      content: unknown;
      localizedContent?: never;
      languageCode?: never;
    };

export const RichText: React.FC<RichTextProps> = ({
  className,
  content,
  localizedContent,
  languageCode,
}) => {
  if (!content) {
    return null;
  }
  let contentToRender = content;
  if (languageCode !== defaultLanguageCode) {
    const matchedLocalizedContent = localizedContent?.find(
      (localizedRichContent) =>
        localizedRichContent.language.code === languageCode,
    );
    if (matchedLocalizedContent) {
      contentToRender = matchedLocalizedContent.richText;
    }
  }
  return (
    <div className={className}>{serialize(contentToRender as Children)}</div>
  );
};
